module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a5-11-781e29e99965f22301e358df650ffdc3.jpg";